import * as yup from 'yup';

export const MSJ_YUP = {
  REQUERIDO: 'Este campo es obligatorio',
  NUMERO: 'Debe ser un número',
  CORREO: 'Correo inválido',
  RUT: 'RUT inválido (Ej: 12345678-9)',
  FECHA: 'Fecha inválida',
  POSITIVO: 'Debe ser un número positivo',
  MAYOR_CERO: 'Debe ser mayor a cero',
  MULTIPLE: 'Debe seleccionar al menos un elemento',
  SELECCIONAR: 'Debe seleccionar una opción',
  LETRAS: 'Debe contener solo letras',
  CELULAR: 'Celular inválido (Debe comenzar con 9, solo 9 dígitos)',
  PATENTE: 'Patente inválida',
  ALFANUM: 'Debe contener solo letras y números',
};

export const REGEX_YUP = {
  CELULAR: /^9\d{8}$/,
  LETRAS: /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/,
  RUT: /^[0-9]{7,8}-[0-9kK]{1}$/,
  PATENTE_ALFANUM: /^(?!-)([A-Za-z0-9-]+)(?<!-)$/,
  ALFANUM: /^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9]+$/,
};

const NOMBRE = yup
  .string()
  .trim()
  .matches(/^[A-Za-zÁÉÍÓÚÑáéíóúñ ]+$/, "Solo letras")
  .min(2, "Debe tener al menos 2 caracteres")
  .max(100)
  .required(MSJ_YUP.REQUERIDO);

const NOMBRE_COMPLETO = yup
  .string()
  .matches(/^[A-Za-zÁÉÍÓÚÑáéíóúñ ]+$/, "Solo letras")
  .min(2, "Debe tener al menos 2 caracteres")
  .max(100)
  .required(MSJ_YUP.REQUERIDO);

const TEXTO = yup
  .string()
  .min(2, "Debe tener al menos 2 caracteres")
  .max(100)
  .required(MSJ_YUP.REQUERIDO);

const NUMERO = yup
  .number()
  .typeError(MSJ_YUP.NUMERO)
  .required(MSJ_YUP.REQUERIDO);

const CELULAR = yup
  .string()
  .matches(REGEX_YUP.CELULAR, MSJ_YUP.CELULAR)
  .required(MSJ_YUP.REQUERIDO);

const CORREO = yup 
  .string()
  .email(MSJ_YUP.CORREO)
  .required(MSJ_YUP.REQUERIDO);

const FECHA = yup
  .date()
  .typeError("Debe ingresar una fecha válida")
  .required("La fecha es obligatoria");

const RUT = yup
  .string()
  .matches(REGEX_YUP.RUT, MSJ_YUP.RUT)
  .required(MSJ_YUP.REQUERIDO);

const SELECT = yup
  .string()
  .required("Debe seleccionar una opción");

const SECUENCIAS = [
  "123", "234", "345", "456", "567", "678", "789",
  "abc", "bcd", "cde", "def", "qwe", "asd", "zxc"
];

const CONTRASENA = yup
  .string()
  .required("La contraseña es obligatoria")
  .min(10, "Debe tener al menos 10 caracteres")
  
  // reglas base
  .matches(/[A-Z]/, "Debe tener al menos una mayúscula")
  .matches(/[a-z]/, "Debe tener al menos una minúscula")
  .matches(/[0-9]/, "Debe tener al menos un número")
  .matches(/[!@#$%&*_\-+=?]/, "Debe tener al menos un carácter especial")
  
  // solo caracteres permitidos
  .matches(
    /^[A-Za-z0-9!@#$%&*_\-+=?]+$/,
    "Contiene caracteres no permitidos"
  )

  // sin espacios
  .test(
    "sin-espacios",
    "No puede contener espacios",
    (value) => !/\s/.test(value || "")
  )

  // evitar secuencias simples
  .test(
    "sin-secuencias",
    "No debe contener secuencias como 123 o abc",
    (value) => {
      if (!value) return true;
      const v = value.toLowerCase();
      return !SECUENCIAS.some(seq => v.includes(seq));
    }
  )

  // evitar repetición excesiva (ej: aaa, 1111)
  .test(
    "sin-repetidos",
    "No debe repetir el mismo carácter muchas veces seguidas",
    (value) => {
      if (!value) return true;
      return !/(.)\1{2,}/.test(value); // 3 o más iguales seguidos
    }
  );


export const VALIDAR = {
  NOMBRE, NOMBRE_COMPLETO,
  CELULAR, CORREO,
  TEXTO, NUMERO, SELECT,
  FECHA,
  RUT,
  CONTRASENA,
};